/**
 * @param onUpdated {(countrySelect: HTMLSelectElement) => void}
 * @return {void}
 */
module.exports = function listenToCountrySelectUpdates(onUpdated) {
    document.querySelectorAll('[data-component="country-select"]').forEach(countrySelect => {
        if (countrySelect instanceof HTMLSelectElement) {
            countrySelect.addEventListener("change", (e) => {
                onUpdated(e.currentTarget);
            });
        }
    });
}